import { Button, ButtonGroup } from "@blueprintjs/core"
import { ChangeEvent, MouseEvent, useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { DIALOG_SIZE, ID, IPost } from "src/libs/interfaces/layouts"
import ConfirmButton from "src/libs/useful/ConfirmButton"
import { __, sprintf } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import * as XLSX from "xlsx"
import { IPETest, PE_TEST_QUESTION_TYPE, PETestQuestion, PETestQuestionAnswer } from "../../data/interfaces"
import getDefaultTest from "../../data/mocks/getDefaultTest"
import { ITestsStore, useTestsStore } from "../../data/store"
import { default as UUID } from "node-uuid";
import actions from "src/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { useDataStore } from "src/modules/pe-basic-module/data/store"

/* Protopia Ecosystem component */
export interface ITestGenLeftProps {
   
}
const TestGenLeft = (props: ITestGenLeftProps): JSX.Element => {
    const ref = useRef(null)
    const genTests: IPETest[]   = useTestsStore((state: ITestsStore) => state.genTests)
    const genCurrentID          = useTestsStore((state: ITestsStore) => state.genCurrentID)
    const PETestCategory: IPost = useDataStore((state: any) => state.PETestCategory || [] )
    const [comment, setComment] = useState<string>("")
    const sheetNames    = useSyncState<string[]>([])
    const sheetName     = useSyncState<string>("")
    const sheets        = useSyncState<any>({})
    const testCats      = useSyncState<any[]>( [] )

    const [isLoad, setIsLoad] = useState<boolean>(false)
    const [questions, setQuestions] = useState<any[]>( [] )
    useEffect(() => {
        actions(GET_FEED_ACTION, { data_type: "PETestCategory" })
    }, [])
    const onAdd = () => {
        const newTest = getDefaultTest()
        const _tests: IPETest[] = [
            ...genTests, 
            newTest
        ]
        useTestsStore.setState({genTests: _tests, genCurrentID: newTest.id})
    }
    const onChoose = (id: ID) => {
        useTestsStore.setState({ genCurrentID: id })
    }
    const onDelete = (evt:MouseEvent<HTMLElement>, id: ID) => {
        evt.stopPropagation()
        evt.preventDefault()
        useTestsStore.setState({
            genTests: genTests.filter(gt => gt.id !== id )
        })
    }
    const onNewTest = () => {
        const tests: IPETest[] = [
            ...genTests,
            {
                ...getDefaultTest(),
                title: sheetName.get() ? sheetName.get() : __("Test") + " " + genTests.length,
                post_content: "",
                questions: questions.map(( q, _order ) => {
                    const answers: any[] = [...q]
                    answers.splice(0, 2)
                    return {
                        id: UUID.v4(),
                        title: !!q[0] ? q[0] : "",          //__("Question" ) + " " + _order,
                        post_content: "",
                        type: q[1],
                        answers: answers.map((a, order) => {
                            return {
                                id: UUID.v4(),
                                title: a?.title,
                                pe_test_category: [ a?.pe_test_category ],
                                post_content: "",
                                order, 
                            } as PETestQuestionAnswer
                        }),
                        range: 6,
                        right_answer_id: "-1",
                        single:true
                        
                    } as PETestQuestion
                })
            } as IPETest
        ]
        useTestsStore.setState({
            genTests: [...tests]
        })
    }
    const onInputClick = () => {
        (ref.current! as any).click()
    }
    const onUpload = (e: ChangeEvent<HTMLInputElement>) => { 
        e.preventDefault()
        const files = e.target.files
        if(!files?.length) return 
        const f = files[0]
        const reader = new FileReader()
        reader.onload = (evt : ProgressEvent<FileReader>) => {
            const data: any = evt.target?.result 
            let readData = XLSX.read( data, { type:"binary"} )
            sheetNames.set( readData.SheetNames )
            sheets.set( readData.Sheets )
            setComment( sprintf(__("Find %s sheets. Select sheet"), sheetNames.get().length.toString() ) )
 
            
        }
        reader.readAsBinaryString(f)
    }
    const onSheet = (wsName:string) => {
        sheetName.set( wsName )
        const ws = sheets.get()[wsName]
        const dataParse: any[] = XLSX.utils.sheet_to_json(ws, {header: 1})
        dataParse.splice(0,1)

        let cats = [...dataParse].filter(d => !!d[0]).map(dp => {
            const d = [...dp]
            d.splice(2)
            return d
        })
        console.log( cats )
        testCats.set( cats )
        

        let results = [...dataParse].map((dp: any[]) => {
            const d = [...dp]
            d.splice(0,4, "", PE_TEST_QUESTION_TYPE.RANGE ) 
            return d
        })
        results = results.map(res => {
            //
            const answer1: string = res[2]
            const cat1 = testCats.get().filter( tc => tc[1] === answer1 )[0]
            //
            const answer2: string = res[3]
            const cat2 = testCats.get().filter( tc => tc[1] === answer2 )[0]
            return [
                res[0], 
                res[1], 
                { title: answer1, pe_test_category: PETestCategory[Number(cat1[0]) - 1] }, 
                { title: answer2, pe_test_category: PETestCategory[Number(cat2[0]) - 1] } 
            ] 
        })
        console.log( results )
        setQuestions( results )
        setIsLoad(true)
        setComment(sprintf(__("Exists %s elements"), dataParse.length.toString()))
    }
    return <div className='pe-test-gen-left-container h-100 overflow-y-auto'>
        {
            genTests.map(gt => {
                return <Link to={`${gt.id}`} className={`d-flex ${gt.id === genCurrentID ? "bg-danger" : ""}`} key={gt.id} onClick={ () => onChoose(gt.id) }  >
                    <div className={`${gt.id === genCurrentID ? "text-light" : "text-force-contrast "} lead-md p-3 w-100 text-overflow`}>
                        {gt.title}
                    </div>
                    <ConfirmButton 
                        buttonLarge 
                        buttonMinimal 
                        buttonIcon="trash" 
                        onConfirm={ (evt: MouseEvent<HTMLElement> ) => onDelete(evt, gt.id) } 
                    >
                        <div className="p-5 text-center">
                            {  __("Do you really want to permanently delete test?") }
                        </div>
                    </ConfirmButton> 
                </Link>
            })
        }
        <Button minimal alignText="left" onClick={onAdd} className="py-1 px-3 w-100">
            <div className="d-flex align-items-center small">
                <i className="fas fa-plus mr-2" />
                <span className="descr text-force-contrast">
                    {__("add new Test")}
                </span>
            </div> 
        </Button>  
        <ConfirmButton
            buttonAlignText="left" 
            buttonFill
            buttonMinimal
            buttonClassName="pe-test-btn"
            buttonLabel={
                <div className="pl-1 d-flex align-items-center">
                    <i className="far fa-file-excel mr-2 " />
                    <span className="descr text-force-contrast small">
                        {__("New Test from Excel file")}
                    </span>
                </div>
            }
            onConfirm={onNewTest}
            dialogClasssName={DIALOG_SIZE.MINIMAL}
            yesLabel={__("Create new test")}
            noLabel={__("Cancel")}
            yesLock={!isLoad}
        >
            <div className="p-5 flex-centered flex-column">
                <Button large onClick={onInputClick}>
                    {__("Upload XLSX-file")}
                </Button>
                <input type="file" ref={ref} onChange={onUpload} style={{width:0, height:0, opacity:0}} />
                <ButtonGroup className="my-2 flex-wrap">
                    {
                        sheetNames.get().map((sn, i) => {
                            return <Button small minimal key={i}><span className="small" onClick={() => onSheet( sn ) }>{sn}</span></Button>
                        })
                    }
                </ButtonGroup>
                <div className=" descr text-force-contrast text-center opacity_75 text-danger">
                    { comment }
                </div>
            </div>
        </ConfirmButton> 
    </div>
}
export default TestGenLeft